import { styleTransfer } from './data/data.styleTransfer';

export const tool = {
  name: 'style-transfer',
  description:
    "A tool that applies visual style transfer to the 3D model's appearance, inspired by a reference image, artistic style, or freestyle description.",
  type: 'function',
  parameters: {
    type: 'object',
    properties: {
      styleTransferStyle: {
        type: 'string',
        description: `ID of the style to use, or a freestyle description. Predefined styles: ${styleTransfer.join(
          ', '
        )}`,
      },
      message: {
        type: 'string',
        default: 'Apply visual style',
      },
    },
    required: ['styleTransferStyle', 'message'],
  },
};
